import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Car, Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin, Youtube } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    axios.get(`${API}/cms/site-settings-v3`)
      .then(res => setSettings(res.data.settings))
      .catch(() => setSettings({
        logo_text: "Roman Cars",
        tagline: "Premium Taxi Service",
        contact: { phone: "+44 123 456 7890", email: "info@romancars.uk", address: "London, UK" },
        social: {},
        footer_text: "© 2024 Roman Cars. All rights reserved."
      }));
    axios.get(`${API}/cms/pages`).then(res => { const pages = (res.data.pages || []).filter(p => p.slug && p.slug.startsWith("airport-taxi")); setLocations(pages); }).catch(() => {});
  }, []);

  const contact = settings?.contact || {};
  const social = settings?.social || {};

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              {settings?.logo_url ? (
                <img src={settings.logo_url} alt="Logo" className="h-10 w-auto" />
              ) : (
                <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center">
                  <Car size={24} className="text-white" />
                </div>
              )}
              <div>
                <h3 className="text-xl font-bold">{settings?.logo_text || "Roman Cars"}</h3>
                <p className="text-gray-400 text-sm">{settings?.tagline || "Premium Taxi Service"}</p>
              </div>
            </Link>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-orange-500">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-orange-500">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-500">Services</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-500">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              {contact.phone && <li className="flex items-center gap-2 text-gray-400"><Phone size={16} className="text-orange-500" /><a href={`tel:${contact.phone}`}>{contact.phone}</a></li>}
              {contact.email && <li className="flex items-center gap-2 text-gray-400"><Mail size={16} className="text-orange-500" /><a href={`mailto:${contact.email}`}>{contact.email}</a></li>}
              {contact.address && <li className="flex items-start gap-2 text-gray-400"><MapPin size={16} className="text-orange-500 mt-1" /><span>{contact.address}</span></li>}
            </ul>
          </div>

        {/* Service Locations */}
        {locations.length > 0 && (
          <div className="border-t border-gray-800 mt-8 pt-6">
            <h4 className="text-lg font-semibold mb-4 text-orange-500">Our Service Locations</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
              {locations.map((loc) => (
                <Link key={loc.slug} to={"/" + loc.slug} className="text-xs text-gray-400 hover:text-orange-500 truncate">{loc.title.replace("Airport Taxi Transfer Service in ", "").replace("Airport Taxi Transfer Services in ", "")}</Link>
              ))}
            </div>
          </div>
        )}
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-3 mb-6">
              {social.facebook && <a href={social.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-orange-500"><Facebook size={18} /></a>}
              {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-orange-500"><Instagram size={18} /></a>}
              {social.twitter && <a href={social.twitter} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-orange-500"><Twitter size={18} /></a>}
            </div>
            <Link to="/book" className="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 font-medium">Book Now</Link>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="text-gray-400 text-sm">{settings?.footer_text || "© 2024 Roman Cars. All rights reserved."}</p>
        </div>
      </div>
    </footer>
  );
}
